import { ComponentAccess } from '../useCurrentAccessPolicy';

export const nursePolicy: ComponentAccess = {
  // LIMS
  canAccessLims: false,
  canCreateOrders: false,
  canEditOrders: false,
  canDeleteOrders: false,
  canManageSpecimens: false,
  canViewDiagnosticReports: false,
  canCreateDiagnosticReports: false,
  canReviewResults: false,
  canManageConsent: false,

  // Admin
  canAccessAdmin: false,
  canManageUsers: false,
  canManageAccessPolicies: false,
  canViewSystemStats: false,

  // Patient Management
  canAccessPatients: true,
  canCreatePatients: true,
  canEditPatients: true,
  canViewPatientHistory: true,
  canManageEncounters: true,
  canViewEncounters: false,

  // Tasks & Workflow
  canAccessTasks: true,
  canClaimTasks: true,
  canAssignTasks: false,
  canCompleteTasksForOthers: false,

  // Practitioner Management
  canAccessPractitioners: true,
  canViewPractitioners: true,
  canManagePractitioners: false,

  // Payment & Billing
  canAccessPayments: false,
  canManageChargeItems: false,
  canManageInvoices: false,
  canViewBillingAccounts: false,

  // Search
  canAccessSearch: true,

  // General
  canViewReports: true,
  canExportData: false,
  canManageDocuments: false,
};
